import { GameEvent } from 'game/events/gameEvent';
import { EventName } from 'game/events/eventsName';
import { Store } from 'game/store/gameStore';
import { updateUIState, uiStore } from 'ui';
import { ActionType } from 'game/quests/types';

export default class MoveCounter {
    private prevValue: string;

    constructor() {
        this.addMove = this.addMove.bind(this);
        this.resetMoves = this.resetMoves.bind(this);

        GameEvent.add(EventName.MOVE, this.addMove.bind(this));
        GameEvent.add(EventName.UNDO_MOVE, this.undoMove.bind(this));
        GameEvent.add(EventName.RESET_GAME, this.resetMoves.bind(this));
        GameEvent.add(EventName.GAME_READY, this.resetMoves.bind(this));
        this.prevValue = Store.movesCount.toString();

        this.updateMovesDisplay();

    }

    public addMove(): void {
        Store.movesCount++;
        this.updateMovesDisplay();

        Store.increaseContextValue('moves').then((context) => {
            GameEvent.emit(EventName.MISSION_ACTION, { type: ActionType.MOVES, payload: context, currentProgress: context.moves });
        });
    }

    public undoMove(): void {
        this.addMove();

        Store.increaseContextValue('undos').then((context) => {
            GameEvent.emit(EventName.MISSION_ACTION, { type: ActionType.UNDO_MOVE, payload: context, currentProgress: context.undos });
        });
    }

    public resetMoves(): void {
        this.updateMovesDisplay();
    }

    private updateMovesDisplay(): void {
        uiStore.dispatch(updateUIState({
            gameStats: {
                ...uiStore.getState().gameUI.gameStats,
                moves: Store.movesCount
            }
        }));

        const refresh = this.prevValue.length != Store.movesCount.toString().length;
        this.prevValue = Store.movesCount.toString();
        if (refresh) {
            GameEvent.emit(EventName.UPDATE_STATISTICS);
        }
    }
}
